import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { DocumentNode, useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';

export interface GenericFieldSelectProps extends FsProps {
  label?: string;
  name?: string;
  isMulti?: boolean;
  query: DocumentNode; // Pass the full GraphQL query
  size?: 'sm' | 'lg';
}
export const GenericFieldSelect = ({
  label,
  name,
  query,
  size = 'sm',
  ...rest
}: GenericFieldSelectProps) => {
  function useGetValues() {
    return useLazyQuery(query, { fetchPolicy: 'network-only' });
  }

  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      hook={useGetValues}
      height={size === 'lg' ? 32 : '22'}
    />
  );
};

